import { render, staticRenderFns } from "./RevisionAnalysesStep.vue?vue&type=template&id=57080b5c&"
import script from "./RevisionAnalysesStep.vue?vue&type=script&lang=js&"
export * from "./RevisionAnalysesStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports